import { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Settings = () => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const navigate = useNavigate();
  const gotoClient = () => {
    navigate('/client');
  };
  const gotoUsermanagement = () => {
    // navigate('/setting/userManagement')
    navigate('/setting/userManagement');
  };

  const gotoRolemanagement = () => {
    navigate('/setting/roleManagement');
  };

  const gotoTeammanagement = () => {
    navigate("/settings/teamManagement");
  };

  const gotoPermissionList = () => {
    navigate('/setting/permissions');
  };

  const gotocustomConfig = () => {
    navigate('/setting/customconfig');
  };
  const gotoMasterUiConfig = () => {
    navigate('/setting/masterUiConfig');
  };
  return (
    <div className="inner-page" style={containerStyle}>
      <div className="breadcrumb pd-left">
        <div>
          <Link to="/home" title="Home">
            Home
          </Link>{' '}
          <span className="hs">/</span>{' '}
          <span title="Settings" className="curr">
            Settings
          </span>
        </div>
      </div>
      <div className="dash-container">
        <div className="tbl_container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12">
              <div className="main-hd">
                <div className="pagetitle">Settings</div>

                <div className="third-div">
                  <div className="heading_item">
                    <button className="add-btn" type="button" onClick={gotoMasterUiConfig}>
                      Master UI Config
                    </button>
                  </div>
                  <div className="heading_item">
                    <button className="add-btn" type="button" onClick={gotoClient}>
                      Clients
                    </button>
                  </div>
                  <div className="heading_item">
                    <button className="add-btn" type="button" onClick={gotoUsermanagement}>
                      UserManagement
                    </button>
                  </div>

                  <div className="heading_item">
                    <button className="add-btn" type="button" onClick={gotoRolemanagement}>
                      RoleManagement
                    </button>
                  </div>

                  <div className="heading_item">
                    <button className="add-btn" type="button" onClick={gotoTeammanagement}>
                      TeamManagement
                    </button>
                  </div>

                  <div className="heading_item">
                    <button className="add-btn" type="button" onClick={gotoPermissionList}>
                      Action Permission
                    </button>
                  </div>

                  <div className="heading_item">
                    <button className="add-btn" type="button" onClick={gotocustomConfig}>
                      Custom Field Configuration
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Settings;
